import { ApiInativarGrupoUsuario, ApiObterGrupoUsuario, ApiObterGrupoUsuarioAtributos, ApiObterGrupoUsuarioPorId, ApiSalvarGrupoUsuario } from '@/api'
import { INATIVAR_GRUPO_USUARIO, OBTER_GRUPO_USUARIO, OBTER_GRUPO_USUARIO_ATRIBUTO, SALVAR_GRUPO_USUARIO } from './mutations-types'

export const ActionObterGrupoUsuario = async ({ commit }, filtros) =>
   await ApiObterGrupoUsuario(filtros)
      .then((response) => commit(OBTER_GRUPO_USUARIO, response))
      .catch(() => commit(OBTER_GRUPO_USUARIO, null))

export const ActionObterGruposUsuarioAtributo = async ({ commit }) =>
   await ApiObterGrupoUsuarioAtributos()
      .then((response) => commit(OBTER_GRUPO_USUARIO_ATRIBUTO, response))
      .catch(() => commit(OBTER_GRUPO_USUARIO_ATRIBUTO, null))

export const ActionObterGrupoUsuarioPorId = async ({ commit }, id) =>
   await ApiObterGrupoUsuarioPorId(id)
      .then((response) => commit(OBTER_GRUPO_USUARIO, response))
      .catch(() => commit(OBTER_GRUPO_USUARIO, null))

export const ActionSalvarGrupoUsuario = async ({ commit }, grupo) =>
   ApiSalvarGrupoUsuario(grupo).then((response) => commit(SALVAR_GRUPO_USUARIO, response))

export const ActionInativarGrupoUsuario = async ({ commit }, id) =>
   ApiInativarGrupoUsuario(id).then((response) => commit(INATIVAR_GRUPO_USUARIO, response))
